"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.PastDeadlineToUseFlexCardViewedAnalyticsEvent = exports.HowToVerifyAccordionOpenedAnalyticsEvent = exports.FaSwitchPaymentMethodResultAnalyticsEvent = exports.FaSwitchPaymentMethodAttemptedAnalyticsEvent = exports.DontUseFlexClickedAnalyticsEvent = exports.DdaHelpMenuClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when the How to Verify Accordion cards are opened
 */
var HowToVerifyAccordionOpenedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('how_to_verify_accordion_opened');
exports.HowToVerifyAccordionOpenedAnalyticsEvent = HowToVerifyAccordionOpenedAnalyticsEvent;
/**
 * Result of change payment method
 */
var FaSwitchPaymentMethodResultAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('fa_switch_payment_method_result');
exports.FaSwitchPaymentMethodResultAnalyticsEvent = FaSwitchPaymentMethodResultAnalyticsEvent;
/**
 * A call to backend to change payment methods is made
 */
var FaSwitchPaymentMethodAttemptedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('fa_switch_payment_method_attempted');
exports.FaSwitchPaymentMethodAttemptedAnalyticsEvent = FaSwitchPaymentMethodAttemptedAnalyticsEvent;
/**
 * Triggers when the DDA Help Menu is clicked
 */
var DdaHelpMenuClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('dda_help_menu_clicked');
exports.DdaHelpMenuClickedAnalyticsEvent = DdaHelpMenuClickedAnalyticsEvent;
/**
 * Triggers when the Don't Use Flex Anywhere button is clicked
 */
var DontUseFlexClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('dont_use_flex_clicked');
exports.DontUseFlexClickedAnalyticsEvent = DontUseFlexClickedAnalyticsEvent;
/**
 * Triggers when the Past Deadline to Use Flex Card is viewed
 */
var PastDeadlineToUseFlexCardViewedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('past_deadline_to_use_flex_card_viewed');
exports.PastDeadlineToUseFlexCardViewedAnalyticsEvent = PastDeadlineToUseFlexCardViewedAnalyticsEvent;
